import React, { useEffect } from "react";
import Header from "@commons/header";
import Tab from "@components/tabs";
import { useSelector } from "react-redux";
import { Module } from "@apis/index";
import { RootState } from "@store/index";
import UnitTable from "./Table";

const UnitList = () => {
  const { data: modules } = useSelector((state: RootState) => state.modules);

  useEffect(() => {
    Module.list({ state: "modules", params: { isActive: true } });
  }, []);

  const items = modules.map((module) => ({
    label: module.name,
    component: UnitTable,
    props: { moduleId: module.id },
  }));
  return (
    <>
      <Header title="All Attributes" />
      <Tab items={items} fitContent paramKey="module" />
    </>
  );
};

export default UnitList;
